import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme:Theme) => createStyles({
    drawerPaper: {
      width: 295,
    },
    
    drawerHeader: {
      display: 'flex',
      flexWrap: 'nowrap',
      padding: theme.spacing.unit,
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      backgroundColor: theme.palette.grey[50],
    },
    drawerTitle: {
      flex: '1 1 auto',
      fontWeight: theme.typography.fontWeightRegular,
    },
    iconRoot: {
      fill: theme.palette.text.secondary,
      // opacity: 0.5,
      margin: 0,
    },
  
    drawerBody: {
      padding: theme.spacing.unit,
    },
  
    fwMedium: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    fwRegular: {
      fontWeight: theme.typography.fontWeightRegular,
    },
  
    detailsTitle: {
      fontWeight: theme.typography.fontWeightMedium,
      margin: `${theme.spacing.unit * 1.5}px 0 ${theme.spacing.unit / 2}px`,
    },
    goalsData:{
      paddingBottom: "10px !important", 
    },
    classVal:{
      overflowWrap: "break-word"
    },
    detailsTable: {
      '& tbody': {
        '& tr': {
          height: 'auto',
          '& td': {
            padding: `${theme.spacing.unit / 2}px 0`,
            border: 0,
            '&:last-child': {
              paddingRight: 0,
            },
          },
        },
      },
    },
  });